module.exports = __webpack_public_path__ + "img/ercode_gansu.d6651799.png";